/**
 * This object is supposed to contain application lifecycle names to which listeners will be added by users of the SDK.
 * At this moment there are no web related events but the object has been created to follow the same structure as other
 * flavor implementations. This is an object containing application lifecycle event names each pointing to an array of
 * listeners to be called when the lifecycle event happens
 * @type {Object}
 * @private
 */
export const appLifecycleListeners = {
  visibilitychange: [],
  isMagicRemoteActive : false
};

